import { combineReducers } from "redux";
import { Action, ActionType } from "app/pages/AgentPricing/actionTypes";
import { PublishedVersionsFetchStatus, AgentCommissionVersion } from "app/pages/AgentPricing/modules/PublishedVersions/state";
import { AgentCommissionVersionDto } from "app/shared/model/AgentCommissionDto";
import { mapToRatesTable } from "app/pages/AgentPricing/models";
import { Country, School } from "app/shared/model";

function status(state: PublishedVersionsFetchStatus|undefined, action: Action) : PublishedVersionsFetchStatus {
    if (!state) {
        return PublishedVersionsFetchStatus.Success;
    }

    switch(action.type) {
        case ActionType.StartFetchPublishedVersions: 
            return PublishedVersionsFetchStatus.Running;
        case ActionType.FetchPublishedVersionsSuccess: 
            return PublishedVersionsFetchStatus.Success;
        case ActionType.ErrorFetchingPublishedVersions: 
            return PublishedVersionsFetchStatus.Errored
        default: 
            return state; 
    }
}

function selected(state: string|undefined, action: Action) : string {
    if (state === undefined) {
        return ''
    }

    switch(action.type) {
        case ActionType.ChangeSelectedPublishedVersion: 
            return action.versionCode; 
        default: 
            return state; 
    }
}

function versions(state: AgentCommissionVersion[]|undefined, action: Action) : AgentCommissionVersion[] {
    if (!state) {
        return [];
    }

    switch(action.type) {
        case ActionType.FetchPublishedVersionsSuccess: 
            return action.versions.map(x => 
                mapToAgentCommissionVersion(x, action.countries, action.schools));

        case ActionType.StartFetchPublishedVersions: 
        case ActionType.ErrorFetchingPublishedVersions: 
            return []; 

        default: 
            return state;
    }
}

function mapToAgentCommissionVersion(dto: AgentCommissionVersionDto, countries: Country[], schools: School[]) : AgentCommissionVersion {
    return {
        name: dto.name,
        rates: mapToRatesTable(dto.agentCommission, countries, schools, false),
        lastUpdatedBy: dto.lastUpdatedBy,
        lastUpdatedDate: dto.lastUpdatedDate,
        ratesFor: dto.ratesFor,
        isCurrent: dto.isCurrent
    }
}

export const reducer = combineReducers({
    status,
    versions, 
    selected
});